function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import Vue from 'vue';
import { VRadioGroup, VRadio } from 'vuetify/lib';
import FormMixin from '../form.mixin';

var Checkbox = /*#__PURE__*/function () {
  function Checkbox() {
    _classCallCheck(this, Checkbox);
  }

  _createClass(Checkbox, null, [{
    key: "register",
    value: function register() {
      Vue.component('roche-radio', {
        template: "<v-radio :ripple=\"false\" v-bind=\"Object.assign({}, $props, $attrs)\" v-on=\"$listeners\" @change=\"$emit('input', $event)\">\n      </v-radio>",
        components: {
          VRadio: VRadio
        }
      });
      Vue.component('roche-radio-group', {
        template: "<v-radio-group\n        v-bind=\"bind\"\n        v-on=\"$listeners\"\n        @change=\"$emit('input', $event)\">\n          <slot></slot>\n        <roche-radio v-for=\"(item, index) of formattedItems\" :value=\"item.value\" :label=\"item.label\" :key=\"index\"></roche-radio>\n      </v-radio-group>",
        mixins: [FormMixin],
        components: {
          VRadioGroup: VRadioGroup
        },
        props: {
          items: {
            type: Array,
            "default": function _default() {
              return [];
            }
          }
        },
        computed: {
          formattedItems: function formattedItems() {
            return this.items.map(function (item) {
              if (item.value && !item.label) item.label = item.value;else if (!item.value && item.label) item.value = item.label;else if (!item.value && !item.label) item = {
                value: item,
                label: item
              };
              return item;
            });
          }
        }
      });
    }
  }]);

  return Checkbox;
}();

export default Checkbox;